<template>
    <!-- SECTION: Campaign Entry -->
    <component
        :is="resolvedComponent"
        v-if="resolvedComponent"
        :slug="slug"
        v-bind="componentProps"
    />
    <div
        v-else
        class="sub-page d-flex justify-center align-center"
        style="min-height: 40vh;"
    >
        <v-progress-circular
            indeterminate
            size="48"
        />
    </div>
    <!-- !SECTION -->
</template>
  
<script>
import api from '@/api';
import DefaultCampaign from '@/views/campaigns/templates/DefaultCampaign.vue';
  
export default {
    name: 'CampaignEntry',
  
    props: {
        slug: { type: String, required: true },
    },
  
    data() {
        return {
            templateKey: 'default',
            resolvedComponent: null,
            campaign: null, // ✅ 모든 템플릿(기본/커스텀)에 내려줄 데이터
        };
    },
  
    computed: {
        // ✅ default/custom 모두 campaign 받게 통일
        componentProps() {
            return { campaign: this.campaign };
        },
    },
  
    watch: {
        slug() {
            this.fetchAndResolve();
        },
    },
  
    async created() {
        await this.fetchAndResolve();
        // console.log('[CampaignEntry] created with slug:', this.slug)
    },
  
    methods: {
        async fetchAndResolve() {
            this.resolvedComponent = null;
            this.campaign = null;

            const lang = (this.$route.params.lang || 'kor').toLowerCase();

            try {
                const res = await api.get(`/TrialBadgeCampaign/${this.slug}/detail`);
                const d = res.data?.data ?? res.data ?? {};

                // ✅ 1) 비노출/비활성 플래그가 내려오면 404로 보냄
                // (필드명은 실제 백엔드 응답에 맞게 하나로 확정해서 쓰는 게 좋습니다)
                const visible =
                    d.showOnPage ?? d.ShowOnPage ??
                    d.isVisible ?? d.IsVisible ??
                    d.isActive ?? d.IsActive ??
                    true;

                if (!visible) {
                    return this.$router.replace({ name: 'NotFoundPage', params: { lang } });
                }

                this.campaign = d;

                const rawTemplateKey = d.templateKey ?? d.TemplateKey ?? d.templatekey ?? 'default';
                this.templateKey = String(rawTemplateKey).trim().toLowerCase();

                if (!this.templateKey || this.templateKey === 'default') {
                    this.resolvedComponent = DefaultCampaign;
                    return;
                }

                // ✅ 2) 템플릿 로딩 실패는 이 단계에서만 폴백 처리
                try {
                    this.resolvedComponent = () =>
                        import(
                            /* webpackChunkName: "campaign-custom" */
                            `@/views/campaigns/custom/${this.templateKey}.vue`
                        );
                } catch (err) {
                    console.warn('[CampaignEntry] custom template import failed:', err);
                    this.resolvedComponent = DefaultCampaign;
                }
            } catch (e) {
                console.warn('[CampaignEntry] detail fetch failed:', e);

                // ✅ 3) 여기서는 폴백 금지 → 404로 이동
                return this.$router.replace({ name: 'NotFoundPage', params: { lang } });
            }
        },
    },
};
</script>